import { render, staticRenderFns } from "./OrderShipmentStateChip.vue?vue&type=template&id=2cbdad78&scoped=true"
import script from "./OrderShipmentStateChip.vue?vue&type=script&lang=ts"
export * from "./OrderShipmentStateChip.vue?vue&type=script&lang=ts"
import style0 from "./OrderShipmentStateChip.vue?vue&type=style&index=0&id=2cbdad78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbdad78",
  null
  
)

export default component.exports